import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    url: string = environment.apiUrl;
    token: string;
    httpOptions;

    constructor(
        private http: HttpClient,
        private route: Router
    ) { }

    fetchToken(done) {
        this.token = localStorage.getItem('token');
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + this.token,
                Accept: 'application/json'
            })
        };

        return done();
    }


    logout(): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/driver/logout', {}, this.httpOptions).pipe(
                tap(data => console.log('data ' + JSON.stringify(data))),
                catchError(this.handleError)
            );
        });
    }

    updateToken(device_token): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/settings/device-token-update', {
                device_type: 'web',
                device_token
            }, this.httpOptions)
                .pipe(
                    tap(data => console.log('[updateToken] : data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    sendMessage(message, to, from, ride_id): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/message/send-message', {
                to_userid: to,
                from_userid: from,
                ride_id,
                message
            }, this.httpOptions)
                .pipe(
                    tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }



    updateLocation(location): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/settings/location-update', {
                lat: location.lat,
                lng: location.lng
            }, this.httpOptions)
                .pipe(
                    tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    offOnClick(status): Observable<any> {
        return this.fetchToken(() => {
            status = status === 1 ? 'offline' : 'online';
            return this.http.post(this.url + '/api/settings/online-or-offline', { status }, this.httpOptions).pipe(
                tap(data => console.log('data ' + JSON.stringify(data))),
                catchError(this.handleError)
            );
        });
    }

    getNearbyDrivers(location): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/driver/get-available-drivers', {
                lat: location.lat,
                lng: location.lng,
                drop_lat: null,
                drop_lng: null
            }, this.httpOptions)
                .pipe(
                    // tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    getNearbyDriversInfo(driverId): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/driver/get-driver-details-by-driver', {
                driver_id: driverId
            }, this.httpOptions)
                .pipe(
                    // tap(data => console.log('data ' + JSON.stringify(data))),
                    catchError(this.handleError)
                );
        });
    }

    getDriverDetails(): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/driver/information', {}, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    currentRideStatus(): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/driver-current-ride-status', {}, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    newBookingRequest(): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/driver-new-booking-request', {}, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }


    acceptRide(rideId: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/accept-ride', { ride_id: rideId }, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    acceptBooking(rideId: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/accept-booking', { ride_id: rideId }, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    expireBooking(rideId: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/expire-ride', { ride_id: rideId }, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    rateRide(rideId: number, rating: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/ride-rating-by-driver', { ride_id: rideId, rider_rating: rating }, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    selectPaymentMode(rideId: number, paymentType: string, amount: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/choose-payment-type-for-meter-taxi',
                { ride_id: rideId, payment_type: paymentType, total_amount: amount }, this.httpOptions).pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    confirmCashReceived(rideId: number, paymentAmount): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/cash-payment-for-meter-taxi',
                { ride_id: rideId, total_amount: paymentAmount }, this.httpOptions).pipe(
                    tap(data => console.log),
                    catchError(this.handleError)
                );
        });
    }

    driverArrived(rideId: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/driver-arrive', { ride_id: rideId }, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    startRide(rideId: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/start-ride', { ride_id: rideId }, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    endRide(rideEndObj: any): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/end-ride', rideEndObj, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    rejectRide(rideId: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/reject-ride', { ride_id: rideId }, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    rejectAdvanceBooking(rideId: number): Observable<any> {
        return this.fetchToken(() => {
            return this.http.post(this.url + '/api/ride/reject-booking', { ride_id: rideId }, this.httpOptions).pipe(
                tap(data => console.log),
                catchError(this.handleError)
            );
        });
    }

    handleError = (err: HttpErrorResponse) => {

        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errorMessage = '';
        if (err.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            errorMessage = `An error occurred: ${err.error.message}`;
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
        }

        if (err.status === 401) {
            localStorage.removeItem('token');
            this.route.navigate(['login']);
            // return false;
            // location.reload();
        }


        console.error(errorMessage);
        return throwError(errorMessage);
    }

}
